import { apiClient } from './client';
import type {
  ResearchInProgressView,
  ResearchTreeView,
  StartResearchActionPDTO,
} from '@/types/research';

const BASE = '/api/v1';

/**
 * Lot 51 (wiki §24.7-bis) - planetId optionnel :
 *   - fourni : CurrentLevel sur chaque node = niveau LOCAL sur cette planete,
 *     GlobalLevel = niveau GLOBAL du joueur ;
 *   - omis : CurrentLevel = GlobalLevel (vue arbre global du joueur-univers).
 */
export async function fetchResearchTree(
  playerUniverseId?: number,
  planetId?: number,
): Promise<ResearchTreeView> {
  const params: Record<string, number> = {};
  if (playerUniverseId !== undefined) params.playerUniverseId = playerUniverseId;
  if (planetId !== undefined) params.planetId = planetId;
  const { data } = await apiClient.get<ResearchTreeView>(`${BASE}/research-tree`, {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchResearchInProgress(playerUniverseId: number): Promise<ResearchInProgressView> {
  const { data } = await apiClient.get<ResearchInProgressView>(`${BASE}/research/in-progress`, {
    params: { playerUniverseId },
  });
  return data;
}

export async function startResearch(
  researchDefinitionId: number,
  body: StartResearchActionPDTO,
): Promise<unknown> {
  const { data } = await apiClient.post(`${BASE}/research/${researchDefinitionId}/start`, body);
  return data;
}
